/**
 * The explicit choice in the shared owlcat-theme cookie, or undefined for "system".
 *
 * Its own module on purpose: ThemeProvider.tsx is a "use client" boundary, so an
 * export living there becomes a client reference and a root layout calling it fails
 * with "Attempted to call parseThemeCookie() from the server but parseThemeCookie is
 * on the client".
 *
 * Pure: the caller reads the cookie (`cookies()` in a root layout) and passes the raw
 * value, so this package forces no app into dynamic rendering.
 */
export function parseThemeCookie(raw) {
    return raw === "light" || raw === "dark" ? raw : undefined;
}
